import { SentryErrorType } from 'Constants/errors'

import { handleFetchErrorFunctional } from '../handleFetchErrorFunctional/handleFetchErrorFunctional.util'

export const handleNewJoinerLogout = () => {
  fetch('/sicherheit/portal/logout', { method: 'POST' })
    .then(() => {
      const newJoinerLoginUrl = window.location.href.split('#')[0]

      window.location.href = newJoinerLoginUrl
    })
    .catch(error => {
      handleFetchErrorFunctional()(error, {
        apiUrl: '/sicherheit/portal/logout',
        location: window?.location || undefined,
        type: SentryErrorType.API_ERROR,
      })
    })
}
